import { render } from "./AppAPIIcon.vue?vue&type=template&id=3b9cfb9c"
import script from "./AppAPIIcon.vue?vue&type=script&lang=js"
export * from "./AppAPIIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__